import { getPolicies, changePolicyPermission } from 'application/adapters/profileInsurance/profileInsuranceAdapter';
import type { PoliciesResult, ChangePolicyPermissionResult } from 'application/adapters/profileInsurance/profileInsuranceAdapter';

export const fetchProfileInsurance = async (hostname: string): Promise<PoliciesResult> => {
	const profileInsurance = await getPolicies(hostname);
	return profileInsurance;
};

export const updatePolicyPermission = async (hostname: string, membershipId: string): Promise<ChangePolicyPermissionResult> => {
	const result = await changePolicyPermission(hostname, membershipId);
	return result;
};
